import { render } from "./PillboxRow.vue?vue&type=template&id=49cf15c4"
import script from "./PillboxRow.vue?vue&type=script&lang=js"
export * from "./PillboxRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__